<template>
  <div ref="accordion" class="accordion accordion-flush"
       :id="`accordion-${id}`">
    <div class="accordion-item element-body" v-for="accordionEl in elements" :key="accordionEl.id">
      <div class="accordion-header" :id="`accordion-header-${id}-${accordionEl.id}`"
           :data-id="accordionEl.id">
        <button v-if="isHasChild(accordionEl)" class="accordion-button collapsed" type="button"
                :data-bs-target="`#accordion-body-${id}-${accordionEl.id}`" data-bs-toggle="collapse"
                @click="loadChild(`${id}-${accordionEl.id}`, accordionEl.links, accordionEl.elements)">
        </button>
        <slot name="title" :id="`${id}-${accordionEl.id}`" :element="accordionEl"></slot>
      </div>
      <div :id="`accordion-body-${id}-${accordionEl.id}`"
           class="accordion-collapse collapse"
           :aria-labelledby="`accordion-header-${id}-${accordionEl.id}`"
           :data-bs-parent="`#accordion-${id}`" :data-id="accordionEl.id">
        <div class="accordion-body">
          <transition name="fade">
          <report-tree v-if="accordionEl.elements" :id="`${id}-${accordionEl.id}`" @loadChild="loadChild"
                       :elements="accordionEl.elements">
            <template v-slot:title="{element, id}">
              <slot name="title" :id="id" :element="element"></slot>
            </template>
          </report-tree>
          <Loader size="1" class="justify-content-start tree-loader" v-else/>
          </transition>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import ReportTree from "@/components/ReportTree"
import Loader from "@/components/common/Loader";

export default {
  name: "Accordion",
  components: {Loader, ReportTree},
  props: {
    elements: {
      type: Array,
      required: true
    },
    id: {
      default: ''
    }
  },
  emits: ['shown', 'loadChild'],

  mounted() {

    this.$refs.accordion.addEventListener('hidden.bs.collapse', e => {
      e.stopPropagation()
    })

    this.$refs.accordion.addEventListener('shown.bs.collapse', e => {
      e.stopPropagation()
      this.$emit('shown', e)
    })
  },
  data() {
    return {}
  },
  methods: {
    loadChild(map, links, elements) {
      if (!elements) {
        this.$emit('loadChild', map, links)
      }

    },
    isHasChild(el) {
      return Boolean(el.links.find(i => i.rel === 'children' && i.action === 'GET'))
    }
  }

}
</script>

<style lang="scss" scoped>
.accordion {
  .accordion-item {
    background-color: transparent;
    border: none;

    .accordion-header {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      position: relative;
    }

    .accordion-body {
      padding: 0 0 0 1em;
      min-height: 30px;

      .tree-loader{
        position: absolute;
        left: 2rem;
        top: 0;
      }
    }

    .accordion-button {
      padding: .3rem 0;
      background: transparent;
      color: inherit;
      width: auto;
      min-width: 10px;
      margin-right: .3rem;

      &:before {
        content: '-';
      }

      &.collapsed:before {
        content: '+';
      }

      &:after {
        display: none;
      }

      &:not(.collapsed) {
        box-shadow: none;
      }

      &:disabled {
        color: #aaa;
      }
    }

    .accordion-collapse {
      margin: 0;
      position: relative;
    }

  }

}
</style>
